module.exports = __webpack_public_path__ + "static/media/189_.8d5e58a0.jpg";